import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Organization } from '../../../../core/models/organization.model';
import { GetOrganizationById, OrganizationState } from '../organization.state';
import { map, Observable, of } from 'rxjs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { OrganizationService } from '../organization.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

interface SettingsMenuItem {
    display: string;
    routerLink: any[];
    routerLinkActiveOptions?: any;
}

@UntilDestroy()
@Component({
    selector: 'organization-detail',
    templateUrl: './organization-detail.component.html',
    styleUrls: ['./organization-detail.component.scss'],
    standalone: true,
    imports: [CommonModule, SharedModule, RouterModule],
})
export class OrganizationDetailComponent implements OnInit {
    public menuItems$: Observable<SettingsMenuItem[]> | undefined;
    public organizationId: string | null = null;
    public myOrga: Organization | undefined | null;

    constructor(
        private readonly store: Store,
        private readonly route: ActivatedRoute,
        private organizationService: OrganizationService,
    ) {}

    ngOnInit() {
        this.route.paramMap.pipe(untilDestroyed(this)).subscribe((paramMap) => {
            this.organizationId = paramMap.get('id');

            const idOrga = this.organizationId;
            const payload = { orgaId: idOrga! };
            this.store.dispatch(new GetOrganizationById(payload));

            this.store.select(OrganizationState.getOrganization).subscribe((organization) => {
                this.myOrga = organization; // Assigner la valeur à `myOrga`
                this.organizationService.setOrganization(this.myOrga); // Envoyer au service
            });
        });

        this.menuItems$ = of(null).pipe(
            map(() => {
                const items = [
                    {
                        display: 'Général',
                        routerLink: ['./general'],
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        display: 'Utilisateurs',
                        routerLink: ['./users'],
                        routerLinkActiveOptions: { exact: false },
                    },
                ];

                return items;
            }),
            untilDestroyed(this),
        );
    }
}
